<template>
    <div>
      <top :title="getTopTitle()"></top>
      <transition :name="transitionName">
        <router-view style="padding-top: 2.5rem;"></router-view>
      </transition>
    </div>
</template>

<script>
  import Top from '@/components/layer2/books/books-top'
  export default {
    name: "books-index",
      data() {
        return {
            transitionName: 'right'
        }
      },
    computed: {

    },
    methods: {
      getTopTitle() {
        return this.$route.meta.topTitle;
      }
    },
    components: {
      top: Top
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/books/index.vue